import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PiPGridState, PiPState } from './types';

const initialGridState: PiPGridState = {
    currentPage: 0,
    maxDisplayParticipants: 2,
};

const initialState: PiPState = {
    isOpen: false,
    closeRequestId: 0, // id запроса на закрытие PiP
    grid: initialGridState,
};

const pipSlice = createSlice({
    name: 'pip',
    initialState,
    reducers: {
        setIsPipOpen(state, action: PayloadAction<boolean>) {
            state.isOpen = action.payload;
        },

        setPiPGridCurrentPage(state, action: PayloadAction<number>) {
            state.grid.currentPage = action.payload;
        },

        setPiPGridMaxDisplayParticipants(state, action: PayloadAction<number>) {
            state.grid.maxDisplayParticipants = action.payload;
        },

        incrementCloseRequestId(state) {
            state.closeRequestId++;
        },

        resetPiPGrid(state) {
            state.grid = initialGridState;
        },
    },
});

export const nextPiPGridPageAction = createAction('conference/pipGrid/nextPage');
export const prevPiPGridPageAction = createAction('conference/pipGrid/prevPage');
export const requestClosePiPAction = createAction('conference/pipGrid/requestClose');

export const pipReducer = pipSlice.reducer;
export const {
    setIsPipOpen,
    setPiPGridCurrentPage,
    setPiPGridMaxDisplayParticipants,
    resetPiPGrid,
    incrementCloseRequestId,
} = pipSlice.actions;
